import { collapsibleCheckboxKey } from './';
import { createCheckboxDriver } from '../../primitives/drivers';
export var createCollapsibleCheckboxDriver = function (wrapper, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$("." + collapsibleCheckboxKey).get(idx);
    var checkbox = createCheckboxDriver(base);
    return {
        body: base.$('.collapsible-body'),
        checkbox: checkbox,
        base: base,
    };
};
//# sourceMappingURL=driver.js.map